import { useDispatch, useSelector } from 'react-redux'
import { signIn, signOut } from '../store/auth'

const UserButton = () => {
  const dispatch = useDispatch()
  const { error, isLoading } = useSelector((state) => state.auth)
  const { displayName } = useSelector((state) => state.firebase.auth)

  return (
    <div className='modal fade' id='myModal' tabIndex='-1' role='dialog' aria-labelledby='myModalLabel'>
      <div className='modal-dialog' role='document'>
        <div className='modal-content'>
          <div className='modal-body'>
            {displayName ? (
              <div>
                <div className='form-group'>Signed in as {displayName}</div>
                <div className='form-group'>
                  <a href='https://edhrec.com/account' rel='noreferrer' target='_blank'>
                    <button type='submit' className='btn btn-primary' disabled={isLoading}>
                      Manage account
                    </button>
                  </a>
                </div>
                <button
                  type='submit'
                  className='btn btn-primary'
                  disabled={isLoading}
                  onClick={() => dispatch(signOut())}
                >
                  Sign out
                </button>
              </div>
            ) : (
              <form
                className='form-horizontal'
                onSubmit={(e) => {
                  e.preventDefault()
                  dispatch(
                    signIn({
                      email: e.target[0].value,
                      password: e.target[1].value,
                    })
                  )
                }}
              >
                <div className='form-group'>
                  <label htmlFor='inputEmail3' className='col-sm-2 control-label'>
                    Email
                  </label>
                  <div className='col-sm-10'>
                    <input type='email' className='form-control' id='inputEmail3' placeholder='Email' />
                  </div>
                </div>
                <div className='form-group'>
                  <label htmlFor='inputPassword3' className='col-sm-2 control-label'>
                    Password
                  </label>
                  <div className='col-sm-10'>
                    <input type='password' className='form-control' id='inputPassword3' placeholder='Password' />
                  </div>
                </div>
                <div className='form-group'>
                  <div className='col-sm-offset-2 col-sm-10'>
                    <button disabled={isLoading} type='submit' className='btn btn-primary'>
                      Sign in
                    </button>
                    <a alt='Sign up' href='https://edhrec.com/signup' style={{ marginLeft: '15px' }}>
                      Sign up
                    </a>
                  </div>
                </div>
                {error && (
                  <div class='alert alert-danger' role='alert' style={{ marginBottom: 0 }}>
                    {error}
                  </div>
                )}
              </form>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default UserButton
